"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactGa = require("react-ga");

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _validation = require("../../validation");

var _Input = require("../Input");

var _formStep = require("../../container/steps/formStep");

var _formStep2 = _interopRequireDefault(_formStep);

var _locale = require("../../locale");

var _locale2 = _interopRequireDefault(_locale);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CustomerDataInput = function (_React$Component) {
  _inherits(CustomerDataInput, _React$Component);

  function CustomerDataInput(props) {
    _classCallCheck(this, CustomerDataInput);

    var _this = _possibleConstructorReturn(this, (CustomerDataInput.__proto__ || Object.getPrototypeOf(CustomerDataInput)).call(this, props));

    _this.fields = [];
    _this.state = {
      showReminder: false,
      isFormValid: false,
      firstName: props.firstName,
      lastName: props.lastName,
      company: props.company,
      email: props.email,
      phone: props.phone,
      message: props.message,
      isCustomer: props.isCustomer,
      reminderMail: props.reminderMail,
      reminderSMS: props.reminderSMS
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    return _this;
  }

  _createClass(CustomerDataInput, [{
    key: "getFormData",
    value: function getFormData() {
      var _state = this.state,
          firstName = _state.firstName,
          lastName = _state.lastName,
          company = _state.company,
          email = _state.email,
          phone = _state.phone,
          message = _state.message,
          isCustomer = _state.isCustomer,
          reminderMail = _state.reminderMail,
          reminderSMS = _state.reminderSMS;
      return {
        stepId: "customer",
        formData: {
          firstName: firstName,
          lastName: lastName,
          company: company,
          email: email,
          phone: phone,
          message: message,
          isCustomer: isCustomer,
          reminderMail: reminderMail,
          reminderSMS: reminderSMS
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateForm();

      _reactGa2.default.event({
        category: "OTB",
        action: "Step",
        label: "Customer"
      });
    }
  }, {
    key: "toggleReminder",
    value: function toggleReminder() {
      this.setState({
        showReminder: !this.state.showReminder
      });
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var valid = true;
      this.fields.forEach(function (field) {
        valid = valid && field.state.valid;
      });

      if (valid !== this.state.isFormValid) {
        this.setState({
          isFormValid: valid
        });
      }

      if (valid) {
        this.props.enableSubmit();
      } else {
        this.props.disableSubmit();
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.type === 'checkbox' ? target.checked : target.value;
      var name = target.name;
      this.setState(_defineProperty({}, name, value), this.validateForm);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement("div", null, _react2.default.createElement("div", {
        className: "sub"
      }, "Pers\xF6nliche Daten"), _react2.default.createElement("div", {
        className: "group"
      }, _react2.default.createElement("div", {
        className: "line"
      }, _react2.default.createElement(_Input.ValidatedInput, {
        ref: function ref(_ref) {
          return _this2.fields[0] = _ref;
        },
        type: "text",
        value: this.state.firstName,
        placeholder: "Vorname",
        name: "firstName",
        onChange: this.handleInputChange,
        validations: [_validation.required]
      }), _react2.default.createElement(_Input.ValidatedInput, {
        ref: function ref(_ref2) {
          return _this2.fields[1] = _ref2;
        },
        type: "text",
        value: this.state.lastName,
        placeholder: "Name",
        name: "lastName",
        onChange: this.handleInputChange,
        validations: [_validation.required]
      }))), _react2.default.createElement("div", {
        className: "group"
      }, _react2.default.createElement("div", {
        className: "line"
      }, _react2.default.createElement(_Input.Input, {
        type: "text",
        value: this.state.company,
        placeholder: "Firma",
        onChange: this.handleInputChange,
        name: "company"
      }))), _react2.default.createElement("div", {
        className: "group"
      }, _react2.default.createElement("div", {
        className: "line"
      }, _react2.default.createElement("div", {
        className: "input-group"
      }, _react2.default.createElement(_Input.ValidatedInput, {
        ref: function ref(_ref3) {
          return _this2.fields[2] = _ref3;
        },
        type: "email",
        value: this.state.email,
        placeholder: "E-Mail-Adressse",
        onChange: this.handleInputChange,
        name: "email",
        validations: [_validation.required, _validation.email]
      })), _react2.default.createElement("div", {
        className: "input-group"
      }, _react2.default.createElement(_Input.ValidatedInput, {
        ref: function ref(_ref4) {
          return _this2.fields[3] = _ref4;
        },
        type: "tel",
        value: this.state.phone,
        placeholder: "Telefonnummer",
        onChange: this.handleInputChange,
        name: "phone",
        validations: [_validation.required, _validation.phone]
      })))), _react2.default.createElement("div", {
        className: "group"
      }, _react2.default.createElement("div", {
        className: "line"
      }, _react2.default.createElement("div", {
        className: "txt"
      }, "Waren Sie schon einmal bei uns?"), _react2.default.createElement("div", {
        className: "right"
      }, _react2.default.createElement("span", {
        className: "switch"
      }, _react2.default.createElement("input", {
        id: "switch-04",
        type: "checkbox",
        name: "isCustomer",
        onChange: this.handleInputChange.bind(this),
        checked: this.state.isCustomer
      }), _react2.default.createElement("label", {
        htmlFor: "switch-04"
      }, _react2.default.createElement("span", null)))))), _react2.default.createElement("textarea", {
        name: "message",
        onChange: this.handleInputChange,
        value: this.state.message,
        placeholder: _locale2.default.getResource("otb_CustomerNotePlaceholder")
      }));
    }
  }]);

  return CustomerDataInput;
}(_react2.default.Component);

CustomerDataInput.propTypes = {
  firstName: _propTypes2.default.string.isRequired,
  lastName: _propTypes2.default.string.isRequired,
  company: _propTypes2.default.string.isRequired,
  email: _propTypes2.default.string.isRequired,
  phone: _propTypes2.default.string.isRequired,
  message: _propTypes2.default.string.isRequired,
  isCustomer: _propTypes2.default.bool.isRequired,
  reminderMail: _propTypes2.default.bool.isRequired,
  reminderSMS: _propTypes2.default.bool.isRequired
};
exports.default = (0, _formStep2.default)(CustomerDataInput);